import React from 'react';
import PropTypes from 'prop-types';
import MultiLineTextArea from 'base/components/MultiLineTextArea';

/**
 * This is textarea component that needs to be used
 * as a component prop in redux-form.
 */
const MultiLineTextAreaField = props => {
  const { input, placeholder, maxLength, defaultValue, dataTestId } = props;
  return (
    <MultiLineTextArea
      placeholder={placeholder}
      value={input.value}
      defaultValue={defaultValue}
      onChange={input.onChange}
      maxLength={maxLength}
      dataTestId={dataTestId}
    />
  );
};

MultiLineTextAreaField.propTypes = {
  input: PropTypes.object,
  placeholder: PropTypes.string,
  maxLength: PropTypes.string,
  defaultValue: PropTypes.string,
  dataTestId: PropTypes.string
};

export default MultiLineTextAreaField;
